import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../../forum/app';
import Component from '../../common/Component';
import SubtreeRetainer from '../../common/utils/SubtreeRetainer';
import Dropdown from '../../common/components/Dropdown';
import listItems from '../../common/helpers/listItems';
import ItemList from '../../common/utils/ItemList';
import LoadingIndicator from '../../common/components/LoadingIndicator';
/**
 * This component can be used on any type of model with an author and content.
 * Subclasses are specialized for specific types of models.
 */
export default class AbstractPost extends Component {
  constructor() {
    super(...arguments);
    /**
     * May be set by subclasses.
     */
    _defineProperty(this, "loading", false);
    /**
     * Ensures that the post will not be redrawn
     * unless new data comes in.
     */
    _defineProperty(this, "subtree", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = false;
    this.subtree = new SubtreeRetainer(() => this.loading, () => this.freshness(), () => {
      const user = this.user();
      return user && user.freshness;
    });
  }
  view(vnode) {
    const attrs = this.elementAttrs();
    attrs.className = this.classes(attrs.className).join(' ');
    const controls = this.controls();
    const footerItems = this.footerItems().toArray();
    return m("article", attrs, this.header(), m("div", {
      className: "Post-container"
    }, m("div", {
      className: "Post-side"
    }, this.sideItems().toArray()), m("div", {
      className: "Post-main"
    }, this.loading ? m(LoadingIndicator, null) : this.content(), m("aside", {
      className: "Post-actions"
    }, m("ul", null, listItems(this.actionItems().toArray()), !!controls.length && m("li", null, m(Dropdown, {
      className: "Post-controls",
      buttonClassName: "Button Button--icon Button--flat",
      menuClassName: "Dropdown-menu--right",
      icon: "fas fa-ellipsis-h",
      onshow: () => this.$('.Post-controls').addClass('open'),
      onhide: () => this.$('.Post-controls').removeClass('open'),
      accessibleToggleLabel: app.translator.trans('core.forum.post_controls.toggle_dropdown_accessible_label')
    }, controls)))), m("footer", {
      className: "Post-footer"
    }, footerItems.length ? m("ul", null, listItems(footerItems)) : null))));
  }
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    return this.subtree.needsRebuild();
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    const $actions = this.$('.Post-actions');
    const $controls = this.$('.Post-controls');
    $actions.toggleClass('openWithin', $controls.hasClass('open'));
  }
  elementAttrs() {
    return {};
  }
  header() {
    return null;
  }
  content() {
    return [];
  }
  classes(existing) {
    let classes = (existing || '').split(' ').concat(['Post']);
    const user = this.user();
    if (this.loading) {
      classes.push('Post--loading');
    }
    if (user && user === app.session.user) {
      classes.push('Post--by-actor');
    }
    if (this.createdByStarter()) {
      classes.push('Post--by-start-user');
    }
    return classes;
  }
  actionItems() {
    return new ItemList();
  }
  footerItems() {
    return new ItemList();
  }
  sideItems() {
    const items = new ItemList();
    items.add('avatar', this.avatar(), 100);
    return items;
  }
  avatar() {
    return null;
  }
}
flarum.reg.add('core', 'forum/components/AbstractPost', AbstractPost);